module.exports = __webpack_public_path__ + "img/file-shield-01.33583060.svg";